import BookMarketerPage from './BookMarketerPage';

export default BookMarketerPage;



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/index.js